export default "__VITE_ASSET__LX0afDb9__"